import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu_logout",
  "use": "icon-menu_logout-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-menu_logout\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\" stroke-linecap=\"round\"><path d=\"M19.215 17.645v1.105c0 1.243-1.119 2.25-2.5 2.25h-10c-1.38 0-2.5-1.007-2.5-2.25V5.25c0-1.243 1.12-2.25 2.5-2.25h10c1.381 0 2.5 1.007 2.5 2.25v1.155M10.992 12h9.901M18.776 8.652L22.139 12M18.776 15.256L22.139 12\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol